<template>
  <div class="d-flex">
    <div style="width: 40%">
      <div class="text-body-2 grey--text font-weight-bold mb-2">
        Breakdown
      </div>
      <screening-trend-matrix
        :screening-outcomes="screeningOutcomes"
      />
    </div>
    <div class="d-flex flex-column align-center flex-grow-1">
      <div class="text-body-2 grey--text font-weight-bold mb-2">
        Relevant
      </div>
      <div
        v-if="screeningOutcomes.length > 0"
        class="text-h5 black--text font-weight-medium mb-2"
      >
        {{ relevantPercentage }}%
      </div>
      <div v-else class="d-flex align-center">
        <span class="text-h5 grey--text font-weight-medium"> - </span>
      </div>
    </div>
    <div class="d-flex flex-column align-center flex-grow-1">
      <div class="text-body-2 grey--text font-weight-bold mb-2">
        Streak
      </div>
      <div
        v-if="screeningOutcomes.length > 0"
        class="d-flex align-center"
      >
        <span
          class="d-inline-block error mr-2"
          :class="streak.color"
          style="width: 10px; height: 10px; border-radius: 50%"
        >
        </span>
        <span class="text-h5 black--text font-weight-medium">
          {{ streak.count }}
        </span>
      </div>
      <div v-else class="d-flex align-center">
        <span class="text-h5 grey--text font-weight-medium"> - </span>
      </div>
    </div>
  </div>
</template>

<script>
import { RelevanceAssessment } from '@/enums';
import { Review } from '@/models';

import ScreeningTrendMatrix from './ScreeningTrendMatrix';

const ASSESSMENT_TO_PROPS = {
  [RelevanceAssessment.RELEVANT]: {
    label: 'Relevant',
    color: 'success',
  },
  [RelevanceAssessment.NOT_SURE]: {
    label: 'Not Sure',
    color: 'warning',
  },
  [RelevanceAssessment.NOT_RELEVANT]: {
    label: 'Not Relevant',
    color: 'error',
  },
  [RelevanceAssessment.UNSCREENED]: {
    label: 'Unscreened',
    color: 'grey lighten-3',
  },
};

export default {
  name: 'ScreeningTrendBreakdown',
  components: {
    ScreeningTrendMatrix,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    screeningOutcomes() {
      return this.review.mostRecentScreeningOutcomes;
    },
    relevantPercentage() {
      const relevantScreeningOutcomes = this.screeningOutcomes.filter(
        (screeningOutcome) =>
          screeningOutcome.outcome === RelevanceAssessment.RELEVANT
      );
      return Math.round(
        (relevantScreeningOutcomes.length /
          this.screeningOutcomes.length) *
          100
      );
    },
    streak() {
      if (this.screeningOutcomes.length === 0) {
        return {
          count: 0,
        };
      } else {
        const latestScreeningOutcome = this.screeningOutcomes[0];
        const indexOfLastDifferingOutcome = this.screeningOutcomes.findIndex(
          (screeningOutcome) =>
            screeningOutcome.outcome !==
            latestScreeningOutcome.outcome
        );
        const count =
          indexOfLastDifferingOutcome > 0
            ? indexOfLastDifferingOutcome
            : this.screeningOutcomes.length;
        const color =
          ASSESSMENT_TO_PROPS[latestScreeningOutcome.outcome].color;

        return { count, color };
      }
    },
  },
};
</script>
